<template>
    <div class="flex items-center gap-3">
        <div class="relative shrink-0">
            <transition name="greet">
                <div
                    v-if="wave && showGreeting"
                    class="absolute bottom-full left-0 z-20 mb-1.5 whitespace-nowrap rounded-2xl rounded-bl-sm border border-white/60 bg-white/95 px-3 py-1.5 text-xs font-medium text-gray-700 shadow-lg backdrop-blur-md"
                >
                    {{ wave }}
                </div>
            </transition>
            <div class="robot-wrap">
                <AnimatedRobot />
            </div>
        </div>
        <div class="min-w-0">
            <p class="truncate text-sm font-semibold text-gray-800">
                {{ title }}
            </p>
            <p v-if="subtitle" class="text-xs text-gray-500">
                {{ subtitle }}
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from "vue";

withDefaults(
    defineProps<{
        title: string;
        subtitle?: string;
        wave?: string;
    }>(),
    { subtitle: "", wave: "" },
);

// The mascot waves periodically, matching the chat welcome launcher.
const showGreeting = ref(false);
let greetTimer: number | undefined;
let hideTimer: number | undefined;

const scheduleWave = (delay: number) => {
    greetTimer = window.setTimeout(() => {
        showGreeting.value = true;
        hideTimer = window.setTimeout(() => {
            showGreeting.value = false;
            scheduleWave(16000);
        }, 5000);
    }, delay);
};

onMounted(() => scheduleWave(800));

onUnmounted(() => {
    window.clearTimeout(greetTimer);
    window.clearTimeout(hideTimer);
});
</script>

<style scoped>
.robot-wrap {
    width: 56px;
    height: 56px;
    animation: headerFloat 3.4s ease-in-out infinite;
    will-change: transform;
}

.robot-wrap :deep(.robot-anim),
.robot-wrap :deep(.robot-anim svg) {
    width: 56px !important;
    height: 56px !important;
}

.robot-wrap :deep(#robotMessage) {
    display: none !important;
}

@keyframes headerFloat {
    0%,
    100% {
        transform: translateY(0) rotate(0deg);
    }
    35% {
        transform: translateY(-7px) rotate(-3deg);
    }
    70% {
        transform: translateY(-3px) rotate(2deg);
    }
}

.greet-enter-active {
    transition:
        opacity 0.25s ease,
        transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.greet-leave-active {
    transition:
        opacity 0.2s ease,
        transform 0.2s ease;
}
.greet-enter-from,
.greet-leave-to {
    opacity: 0;
    transform: translateY(6px) scale(0.9);
}

@media (prefers-reduced-motion: reduce) {
    .robot-wrap {
        animation: none !important;
    }
}
</style>
